import Button from 'react-bootstrap/Button';
import { MdGroupAdd  } from "react-icons/md";
import { FaUsersCog } from "react-icons/fa";
import { Accordion, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import NewGroup from '../../components/Modals/Create/NewGroup';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const GroupAdministration = ({titre}) => {

    const navigate = useNavigate();
    const { hasPermission } = useAuth();

    const [showNewGroup, setShowNewGroup] = useState(false);
    
    const handleClick = () => {
        navigate('/administration-utilisateur')
    }

    const handleShowNewGroup = () => {
        setShowNewGroup(true);
    }

    return (

        <>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">{titre}</h1>
                <div>
                    <Button variant="secondary" className=" btn-icon-split mr-2" onClick={handleClick}>
                        <span className="icon text-white "><FaUsersCog size={20} /></span>
                        <span className="text">Gérer les utilisateurs</span>
                    </Button>
                    {hasPermission('CREATE_GROUP') && (
                    <Button variant="warning" className=" btn-icon-split" onClick={handleShowNewGroup}>
                        <span className="icon text-white "><MdGroupAdd size={20} /></span>
                        <span className="text">Ajouter un groupe</span>
                    </Button>
                    )}
                </div>
            </div>

            <div className='row'>
                <div className='col-12'>
                    <Card className="border-left-group shadow mb-4">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header >
                                    <h6 style={{ color: "black" }} className='m-0 font-weight-bold text-body'>Liste des groupes</h6>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Aucun groupe trouvé.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card>
                </div>
            </div>

            <NewGroup showNewGroup={showNewGroup} setShowNewGroup={setShowNewGroup}/>
        </>

    )
}

export default GroupAdministration